module.exports = __webpack_public_path__ + "static/media/LectureSeriesImg2.14c4d7e9.jpeg";